import React from 'react';
import { useUserDataAction } from 'store';
import { useGetShopOrders } from 'hooks/ShopOrderHooks';
import { useGetParcelServices } from 'hooks/ParcelServiceHooks';
import { useGetRentals } from 'hooks/RentalHooks';

const useMyShopOrderList = (userId) => {
  /* ===== Store ===== */
  const action = useUserDataAction();

  /* ===== Variables ===== */
  // NOTE: 쿼리
  const query = {
    user_id: userId,
    // join_tables: `["review"]`,
  };
  // NOTE: 쿼리 옵션
  const options = {
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return [];
      else return data;
    },
    enabled: !!userId,
    initialData: [],
  };

  /**
   * SECTION 주문 데이터
   * --
   */
  const { data: ShopOrderList } = useGetShopOrders(query, options);
  const { data: ParcelServices } = useGetParcelServices(
    { ...query, join_tables: '["refund"]' },
    options,
  );
  const { data: Rental } = useGetRentals(
    {
      ...query,
      join_tables: '["refund", "rental_extension"]',
    },
    options,
  );

  const newShopOrderList = React.useMemo(() => {
    if (!ShopOrderList.length && !ParcelServices.length && !Rental.length)
      return [];

    const newParcelServices = ParcelServices.map((parcel) => {
      const { refund } = parcel;

      return {
        ...parcel,
        refund: refund && refund.length ? refund[0] : null,
      };
    });

    const newRental = Rental.map((rental) => {
      const { refund } = rental;

      return {
        ...rental,
        refund: refund && refund.length ? refund[0] : null,
      };
    });

    return ShopOrderList.map((order) => ({
      ...order,
      parcel_service: newParcelServices.filter(
        (parcel) => order.shop_order_id === parcel.shop_order_id,
      ),
      rental: newRental.filter(
        (rental) => order.shop_order_id === rental.shop_order_id,
      ),
    }));
  }, [ShopOrderList, ParcelServices, Rental]);

  React.useEffect(() => {
    if (!newShopOrderList.length) return;

    action.setData('orderList', newShopOrderList);
    // eslint-disable-next-line
  }, [newShopOrderList]);

  return newShopOrderList;
};

export default useMyShopOrderList;
